// src/components/Promos/DonateButton.jsx
import React from "react";

export default function DonateButton({
  onClick,
  label = "Don",
  className = "",
}) {
  return (
    <button
      type="button"
      className={`promos-btn promos-btn--donate ${className}`.trim()}
      onClick={onClick}
    >
      🤍 {label}
    </button>
  );
}
